export default __webpack_public_path__ + "static/media/Aura-Egg__08.f76252f3.png";